import React from 'react';
import { Badge } from '@/components/ui/badge';

interface MatchScoreBadgeProps {
  softSignalsMet: number;
}

export function MatchScoreBadge({ softSignalsMet }: MatchScoreBadgeProps) {
  const accent: 'success' | 'warning' | 'destructive' = softSignalsMet === 3 ? 'success' : softSignalsMet >= 2 ? 'warning' : 'destructive';
  return (
    <Badge variant="accent" accent={accent} className="text-xs font-semibold px-1.5 py-0 leading-5 tabular-nums whitespace-nowrap">
      {softSignalsMet} of 3 met
    </Badge>
  );
}
